import { render } from "./loading.vue?vue&type=template&id=622b7cda&scoped=true&ts=true"
import script from "./loading.vue?vue&type=script&lang=ts"
export * from "./loading.vue?vue&type=script&lang=ts"

import "./loading.vue?vue&type=style&index=0&id=622b7cda&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622b7cda"]])

export default __exports__